import { BaseError, ErrorOptions } from './base.error';

export class RequestValidationError extends BaseError {
  constructor(message?: string, statusCodeOrOptions?: number | ErrorOptions) {
    let options = { statusCode: 400 };
    if (typeof statusCodeOrOptions === 'number') {
      options = {
        statusCode: statusCodeOrOptions
      };
    } else {
      options = {
        ...options,
        ...statusCodeOrOptions
      };
    }

    super(`Invalid Request${message ? `: ${message}` : ''}`, options);
  }
}
